import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ParentSize } from "@visx/responsive";
import { ApplicationState } from '../../../reducers/Index';
import { loadNewEmployeeReport, loadNewEmployeeSharedReport } from '../../../actions/NewEmployeeReportActions';
import { UserNewEmployeeReportState, NewEmployeeReportAction } from '../../../interface/NewEmployeeReportInterface';
import MapContainer from '../../Common/MapContainer';
import { numberWithCommas, groupBy } from '../../Common/Helpers';
import renderHTML from 'react-render-html';
import { isAgg } from '../../Common/Helpers';
import TopCompanies from './TopCompanies'
import EmployeeCounts from './EmployeeCounts'
import Earnings from './Earnings'
import { exportEmployeeReportImage } from './NewEmployeeReportButtonHelpers'
import ViewReportModal from '../ViewReportModal';
import { downloadNewEmployeeReportData } from "./../../../actions/NewEmployeeReportActions";

// track user visit
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { Heading1, Heading2, Heading3, IRISLightGreyDivider, ReportText, CondensedReportText, TextLink, TextSpan } from '../../Common/SharedStyledComponents';
import styled, { css } from "styled-components";
import { Col, Row } from 'react-bootstrap';
import { IrisColors } from '../../../css/IRISColors';
import LoadingSpinner from '../../Common/LoadingSpinner';

interface NewEmployeeReportState {
    currentDateTime?: any;
    selectedEarnings?: any;
    selectedCounts?: any;
    selectedCompanySalaries?: any;
    industries?: any;
    userError?: any;
    companies?: any;
    currentPage?: any;
    pageCount?: any;
    employeeTypes?: any;
    selectedState?: any;
    showFilterLocation?: any;
    showFilterEmployeeTypes?: any;
    showFilterIndustries?: any;
    classShrink?: any;
    showMore?: any;
}

class NewEmployeeReport extends React.Component<NewEmployeeReportAction & UserNewEmployeeReportState & RouteComponentProps<{}>, NewEmployeeReportState> {
    mapRef: React.RefObject<any>; 
    constructor(props) {
        super(props);
        this.mapRef = React.createRef();
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        let defaultTrue = true, defaultFalse = false;
        //for UT Dallas do the opposite!
        if (this.props.UserState.report_display_id == 69211) {
            defaultTrue = !defaultTrue
            defaultFalse = !defaultFalse
        }

        this.state = {
            currentDateTime: currentDate,
            currentPage: 0,
            employeeTypes: [
                { type: "Undergraduate", color: { fill: 'rgb(63, 81, 181)', stroke: 'rgb(50, 65, 145)' }, selected: defaultTrue },
                { type: "Graduate Student", color: { fill: 'rgb(33, 150, 243)', stroke: 'rgb(26, 120, 194)' }, selected: defaultTrue },
                { type: "Postdoc", color: { fill: 'rgb(67, 160, 71)', stroke: 'rgb(54,128,57)' }, selected: defaultTrue },
                { type: "Staff", color: { fill: 'rgb(255,193,7)', stroke: 'rgb(204,154,6)' }, selected: defaultFalse },
                { type: "Faculty", color: { fill: 'rgb(255,87,34)', stroke: 'rgb(204,70,27)' }, selected: defaultFalse },
                { type: "Other Student", color: { fill: 'rgb(233,30,99)', stroke: 'rgb(186,24,79)' }, selected: defaultFalse }
            ],
            selectedEarnings: [],
            selectedCounts: [],
            selectedCompanySalaries: [],
            companies: [],
            industries: [],
            userError: false,
            selectedState: {
                "name": "United States",
                "abbreviation": "USA",
                "statecode": 0
            },
            showFilterLocation: true,
            showFilterEmployeeTypes: true,
            showFilterIndustries: true,
            classShrink: false,
            showMore: false
        };
        this.right = this.right.bind(this);
        this.left = this.left.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.loadIndustries = this.loadIndustries.bind(this);
    }

    handleFilterClick(item) {
        if (item == "location") {
            this.setState({
                showFilterLocation: !this.state.showFilterLocation
            });
        }
        else if (item == "employeeTypes") {
            this.setState({
                showFilterEmployeeTypes: !this.state.showFilterEmployeeTypes
            });
        }
        else if (item == "industries") {
            this.setState({
                showFilterIndustries: !this.state.showFilterIndustries
            });
        }
    }
    
    reportHeight = 0;

    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {
            this.props.loadNewEmployeeSharedReport(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"]);
        } else {
            this.props.loadNewEmployeeReport(this.props.UserState.report_display_id, this.props.UserState.report_vintage_sb_employee);
        }

        const height = document.querySelector("#report-col");
        this.reportHeight = height ? height.scrollHeight + 1100 : 0
    }

    componentDidUpdate(prevProps) {
        if ((this.props.NewEmployeeReportState !== prevProps.NewEmployeeReportState)
            && this.props.NewEmployeeReportState
            && this.props.NewEmployeeReportState.EmployeeNationalLocation
            && this.props.NewEmployeeReportState.EmployeeBarPlot
            && this.props.NewEmployeeReportState.EmployeeBoxPlot
            && this.props.NewEmployeeReportState.EmployeeCompany) {

            this.setState({ pageCount: Math.ceil((this.props.NewEmployeeReportState.EmployeeNationalLocation.length - 20) / 5) });

            if (this.props.NewEmployeeReportState && this.props.NewEmployeeReportState.EmployeeBarPlot && this.props.NewEmployeeReportState.EmployeeBarPlot.length > 1) {
                this.loadStuff();
            }
        }
    }

    async loadStuff() {
        this.loadIndustries(this.props.NewEmployeeReportState.EmployeeBarPlot, this.state.selectedState.statecode);
    }

    exportChart = (chartDiv, chartName) => {
        exportEmployeeReportImage(chartDiv, chartName, this.props.NewEmployeeReportState, this.props.UserState.report_display_id, this.state.currentDateTime, "yes", this.props.UserState.report_vintage_sb_employee);
    }

    exportTheMap = () => {
        exportEmployeeReportImage("#employee-map", "employee-map.png", this.props.NewEmployeeReportState, this.props.UserState.report_display_id, this.state.currentDateTime, "yes", this.props.UserState.report_vintage_sb_employee);
    }
  
    loadIndustries(employeeBarPlot, stateCode) {
        let industries = [];
        var indy = groupBy(employeeBarPlot.filter(x => +x.statecode == stateCode), "industry");
        Object.keys(indy).forEach(item => {
            let total = indy[item].map(x => { return x.count }).reduce(function (p, c) { return p + c; });
            industries.push({ type: (item), count: total, selected: false });
        })
        industries = industries.sort((a, b) => (a.count < b.count) ? 1 : -1);
        let i = 0;
        let min = Math.min(5, industries.length);
        for (i = 0; i < min; i++) {
            industries[i].selected = true;
        }
        this.setState({
            industries: industries,
        });
        return industries;
    }
    
    destinationList = () => {
        const top20Destinations = this.props.NewEmployeeReportState.EmployeeNationalLocation.slice(0, 5);
        return (
            <DestinationsList>
                {top20Destinations.map((item, idx) => (
                    <CondensedReportText key={item.statecode ? item.statecode.concat(idx) : idx}>
                        <TextSpan>{idx + 1}</TextSpan>. {item.statename} ({item.count == 0 || item.count == undefined || item.count == null ? "< 5" : numberWithCommas(item.count)})
                    </CondensedReportText>))}
            </DestinationsList>
        )
    };

    left() {
        this.setState({ currentPage: Math.max(0, this.state.currentPage - 1) });
    }
    right() {
        this.setState({ currentPage: Math.min(this.state.pageCount, this.state.currentPage + 1) });
    }

    handleEmployeeTypeChange = (id, event) => {
        let newtypes = [];
        this.state.employeeTypes.forEach(type => {
            if (type.type == id)
                type.selected = !type.selected;

            newtypes.push(type);
        })

        this.setState({
            employeeTypes: newtypes
        });
    }
    
    IndustryChange = (id, event) => {
        let newtypes = [];

        this.state.industries.forEach(type => {
            newtypes.push({ type: type.type, selected: (type.type == id) ? !type.selected : type.selected, count: type.count });
        })

        const count = newtypes.filter(t => t.selected).length;
        if (count >= 6) {
            this.setState({ userError: true });
        }
        else {
            this.setState({
                industries: newtypes,
                userError: false
            });
        }
    }


    employeeMapClick = (clickedState) => {
        // Use functional setState to batch updates
        this.setState(prevState => ({
            selectedState: {
                "name": clickedState.name,
                "abbreviation": "",
                "statecode": clickedState.statecode
            }
        }), () => {
            // This callback ensures the state update is complete before loading industries
            this.loadIndustries(this.props.NewEmployeeReportState.EmployeeBarPlot, clickedState.statecode);
        });
    }

    getCorrectText = (reportDisplayId) => {
        let names = "";
        if (reportDisplayId == "999075")
            names = "IRIS Member Universities";
        else if (reportDisplayId == "999077")
            names = "Research Universities for Michigan";
        else if (reportDisplayId == "999076")
            names = "Texas CPUPC IRIS Members";
        else
            names = "your institution";
        return names;
    }

    getCorrectText2 = (reportDisplayId) => { 
        let names = "";
        if (reportDisplayId == "999075")
            names = "IRIS Member Universities";
        else if (reportDisplayId == "999077")
            names = "Research Universities for Michigan";
        else if (reportDisplayId == "999076")
            names = "Texas CPUPC IRIS Members";
        else
            names = "your university";
        return names;
    }

    getCorrectText3 = (reportDisplayId) => {
        let names = "";
        if (reportDisplayId == "999075")
            names = "IRIS Member Universities'";
        else if (reportDisplayId == "999077")
            names = "Research Universities for Michigan's";
        else if (reportDisplayId == "999076")
            names = "Texas CPUPC IRIS Members'";
        else
            names = "your university's";
        return names;
    }


    public render() {
        const empMap = document.getElementById('empMap');
        if (empMap) {
            setTimeout(
                () => exportEmployeeReportImage("#employee-map", "employee-map.png", this.props.NewEmployeeReportState, this.props.UserState.report_display_id, this.state.currentDateTime, "no", this.props.UserState.report_vintage_sb_employee),
                10000
            );
        }

        const { path } = this.props.match;

        let agg = isAgg(this.props.UserState.report_display_id);

        
        const myIndustries = () => (
            this.state.industries.length > 0 ?
                <div className="filter_options filter_options_types">
                    {this.state.industries.map((item, idx) => {
                        return <div key={idx}><input key={item.type} type="checkbox" onChange={(e) => this.IndustryChange(item.type, e)} checked={item.selected} />{`${item.type} (${numberWithCommas(item.count)})`}</div>
                    })}
                </div> :
                <div className="employee-report-refresh"><i className="glyphicon glyphicon-refresh"></i></div>
        )
        
        let logoUni;
        try {
            logoUni = require(`../../../images/univ_logos/${this.props.UserState.report_display_id}.png`);
        }
        catch (err) {
        }

        const steppingBlocks = require('../../../images/Steppingblocks.png');

        const height = document.querySelector("#report-col");

        const { state_text, state_text2, EmployeeBarPlot, EmployeeBoxPlot, EmployeeNationalLocation, EmployeeCompany } = this.props.NewEmployeeReportState;

        if (!EmployeeBarPlot || !EmployeeBoxPlot || !EmployeeNationalLocation || !EmployeeCompany) return <LoadingSpinner loadingText="Loading Report Data..." />

        var loadSharedLink = false;

        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        if (sharedLinkPageOnLoad) {
            loadSharedLink = true;
        }
        let isSharedReport = this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        console.log(this.props.NewEmployeeReportState)
        console.log(this.state);
         
        //const date = this.props.NewEmployeeReportState && this.props.NewEmployeeReportState.employeeRelease;
        const { start_year, end_year } = this.props.NewEmployeeReportState.EmployeeMethodology;

        const state_and_date = ' - ' + this.state.selectedState.name + ', ' + start_year + "-" + end_year;        
        //console.log(state_and_date)
        const isNational = this.state.selectedState.statecode === 0;

        const mapData = isNational
            ? this.props.NewEmployeeReportState.EmployeeNationalLocation
            : this.props.NewEmployeeReportState.EmployeeLocation;

        const hasMapData = this.props.NewEmployeeReportState.EmployeeProfileInfo && mapData;

        return (
            <ReportContainer>
                {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Employee"} /> : null}
                {(!sharedLinkPageOnLoad ||
                    ((sharedLinkPageOnLoad && this.props.UserState.sharedLinkEmailSubmitted) || this.props.match.params["ne"])) &&
                    <ReportContent id="report-content">
                        <Row>
                            <Col lg={12} md={12} id="report-col">
                                <Heading1 bold id="summary">Employee Profile Report</Heading1>
                                <CondensedReportText>
                                    This report characterizes the career pathways of research-funded employees at {this.getCorrectText2(this.props.UserState && this.props.UserState.report_display_id)} by showing their locations, employment sectors and earnings at their places of employment after they leave {this.getCorrectText(this.props.UserState && this.props.UserState.report_display_id)}. The years indicate when the individuals in the data were employed at {this.getCorrectText2(this.props.UserState && this.props.UserState.report_display_id)}.
                                </CondensedReportText>
                                <CondensedReportText>
                                    All the charts and maps in this report are downloadable, as are the underlying data. The entire report can also be shared using the "Share Report" button.
                                </CondensedReportText>
                                <CondensedReportText>
                                    The report is created by linking administrative data provided by {this.getCorrectText2(this.props.UserState && this.props.UserState.report_display_id)} with employment, location and earnings data from multiple sources. See methodology document for more details.
                                </CondensedReportText>
                                <Heading2 bold id="geographic-destinations">Geographic Destinations</Heading2>
                                <CondensedReportText>This map shows where research-funded employees found jobs after leaving {this.getCorrectText2(this.props.UserState && this.props.UserState.report_display_id)}. Click on a state to see state- and county-level views. This report is summed across cohorts and across fiscal years, so that any employee moving to a given state is counted in the total for that state, regardless of the year that the move took place.</CondensedReportText>
                                <Heading3 bold center>Destinations of Research-Funded Employees, {start_year}-{end_year}</Heading3>
                                <MapActionsArea>
                                    {(this.state.selectedState.statecode == 0) && <ClickStateArea>Click on a state for a more detailed view.</ClickStateArea>}
                                    {(this.state.selectedState.statecode != 0) && <TextLink onClick={() => this.employeeMapClick({ statecode: 0, name: 'United States' })} >← National Map</TextLink>}
                                    <ExportMapArea><a style={{ cursor: "pointer", fontSize: "14px", textDecoration: "none" }} className="export" onClick={this.exportTheMap}><i className="fa fas fa-download ecr_export"></i>EXPORT CHART (BELOW)</a></ExportMapArea>
                                </MapActionsArea>
                                 <div style={{ width: "100%" }}>
                                  {hasMapData && (
                                    <div className="saveThisMap" id="employee-map" style={{ margin: "auto" }}>
                                      <MapContainer
                                        ref={this.mapRef}
                                        agg={agg}
                                        isEmployee={true}
                                        isInState={!isNational}
                                        state_fips={this.state.selectedState.statecode}
                                        mapData={mapData}
                                        nationalData={this.props.NewEmployeeReportState.EmployeeNationalLocation}
                                        stateData={this.props.NewEmployeeReportState.EmployeeLocation}
                                        {...(isNational && { employeeMapClick: this.employeeMapClick })}
                                      />
                                    </div>
                                  )}
                                </div>
                                <Row>
                                <Col>
                                    <Heading3 bold>Top 5 States, with employee counts</Heading3>
                                    {this.props.NewEmployeeReportState.EmployeeLocation && this.destinationList()}
                                </Col>
                                <Col>
                                    <Heading3 bold>Highlights</Heading3>
                                    <ul>
                                        <li><CondensedReportText>{state_text && renderHTML(state_text)}{!state_text && <i className="glyphicon glyphicon-refresh"></i>}</CondensedReportText></li>
                                        <li><CondensedReportText>{state_text2 && renderHTML(state_text2)}{!state_text2 && <i className="glyphicon glyphicon-refresh"></i>}</CondensedReportText></li>
                                    </ul>
                                </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "1.6rem" }}>
                            <Col lg={9} md={9} id="report-col">
                                <Heading2 bold id="sectors-and-earnings">Sectors and Earnings</Heading2>
                                <CondensedReportText>These charts show the industry sectors and earnings of {this.getCorrectText3(this.props.UserState && this.props.UserState.report_display_id)}  research-funded employees in their jobs after leaving {agg ? 'their universities' : 'the university'}. Using the filter selection tool on the right, you can choose the most relevant types of employees and industry sectors to view.</CondensedReportText>
                                {this.props.NewEmployeeReportState.EmployeeBarPlot && this.props.NewEmployeeReportState.EmployeeProfileInfo &&
                                    <div>
                                    <a style={{ marginTop: "1.2rem", fontSize: "14px", textDecoration: "none", cursor: "pointer" }} className="export" onClick={() => this.exportChart("#chart1", "chart1.png")}><i className="fa fas fa-download ecr_export"></i>EXPORT CHART (BELOW)</a>
                                        <div id="chart1" className="chartimage parent">
                                            <ParentSize>
                                                {
                                                    parent => (
                                                        <EmployeeCounts
                                                            EmployeeBarPlot={this.props.NewEmployeeReportState.EmployeeBarPlot}
                                                            statecode={this.state.selectedState.statecode}
                                                            employeeTypes={this.state.employeeTypes}
                                                            industries={this.state.industries}
                                                            title={`Industries of Research-Funded Employees ${state_and_date}`}
                                                            state={this.state}
                                                            props={this.props}
                                                            parentWidth={parent.width}
                                                        />
                                                    )
                                                }

                                            </ParentSize>
                                        </div>
                                    </div>
                                }
                                <br />
                                <br />
                                {this.props.NewEmployeeReportState.EmployeeBoxPlot && this.props.NewEmployeeReportState.EmployeeProfileInfo &&
                                    <div>
                                        <a style={{ marginTop: "1.2rem", fontSize: "14px", textDecoration: "none", cursor: "pointer" }} className="export" onClick={() => this.exportChart("#chart2", "chart2.png")}><i className="fa fas fa-download ecr_export"></i>EXPORT CHART (BELOW)</a>
                                        <div id="chart2" className="chartimage parent">
                                            <ParentSize>
                                                {
                                                    parent => (
                                                        <Earnings
                                                            statecode={this.state.selectedState.statecode}
                                                            employeeTypes={this.state.employeeTypes}
                                                            industries={this.state.industries}
                                                            title={`Earnings by Industries of Research-Funded Employees ${state_and_date}`}
                                                            state={this.state}
                                                            props={this.props}
                                                            parentWidth={parent.width}
                                                            parentHeight={parent.height}
                                                        />
                                                    )
                                                }

                                            </ParentSize>
                                        </div>
                                    </div>
                                }
                                <br />
                                {this.props.NewEmployeeReportState.EmployeeCompany && this.props.NewEmployeeReportState.EmployeeProfileInfo && this.state.selectedState.statecode == "0" &&
                                    <div>
                                        <a style={{ marginTop: "1.2rem", fontSize: "14px", textDecoration: "none", cursor: "pointer" }} className="export" onClick={() => this.exportChart("#earnings-in-top-10-companies", "earnings-in-top-10-companies.png")}><i className="fa fas fa-download ecr_export"></i>EXPORT CHART (BELOW)</a>
                                        <div className="chartimage">
                                            <ParentSize>
                                                {
                                                    parent => (
                                                        <TopCompanies
                                                            EmployeeCompany={this.props.NewEmployeeReportState.EmployeeCompany}
                                                            statecode={this.state.selectedState.statecode}
                                                            employeeTypes={this.state.employeeTypes}
                                                            industries={this.state.industries}
                                                            agg={agg}
                                                            university={this.props.NewEmployeeReportState.EmployeeProfileInfo.university}
                                                            state={this.state}
                                                            props={this.props}
                                                            parentWidth={parent.width}
                                                        />
                                                    )
                                                }
                                            </ParentSize>
                                        </div>
                                        <ReportText>{!isSharedReport && <span>A full list of employees and respective earnings of employee types are available for download <TextLink onClick={() => downloadNewEmployeeReportData(this.props.NewEmployeeReportState)}>here</TextLink>.</span>}</ReportText>
                                    </div>
                                }
                                <div>
                                </div>
                                <img height="50px" src={String(steppingBlocks)} alt='Logo'></img>

                            </Col>
                            {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Employee"} /> : null}
                            {(!sharedLinkPageOnLoad ||
                                ((sharedLinkPageOnLoad && this.props.UserState.sharedLinkEmailSubmitted) || this.props.match.params["ne"])) &&
                                <Col lg={3} md={3}>
                                    <FilterContainer>
                                        <Heading3 bold>Graph Filters</Heading3>
                                        <CheckboxGroup>
                                            <CondensedReportText bold>Employee Types</CondensedReportText>
                                            {this.state.showFilterEmployeeTypes &&
                                                <div className="filter_options">
                                                    {this.state.employeeTypes.map((item, idx) => (
                                                        <div key={idx}><input type="checkbox" key={item.type} onChange={(e) => this.handleEmployeeTypeChange(item.type, e)} checked={item.selected} />{item.type}</div>
                                                    ))}
                                                </div>}
                                        </CheckboxGroup>
                                        <br />
                                        <CheckboxGroup>
                                            <CondensedReportText bold>Industries</CondensedReportText>
                                            <CondensedReportText>(count of all employee types)</CondensedReportText>
                                            {this.state.userError && <span style={{ color: "red" }}>(Select up to 5)</span>}
                                            {this.state.showFilterIndustries && myIndustries()}
                                        </CheckboxGroup>
                                    </FilterContainer>
                                </Col>
                            }
                        </Row>
                    </ReportContent>
                }
            </ReportContainer>
        );
    }
}
const MapActionsArea = styled.div`
    position: relative;
`;
const ClickStateArea = styled.div`
    position: absolute;
    top: 0;
    width: 120px;
    padding: 0 0.2em;
    font-family: Arial Narrow;
    border: solid 1px darkgray;
    font-size: 14px;
`;

const ExportMapArea = styled.div`
    position: absolute;
    padding: 0 0.2em;
    left: 880px;
    top: 0px;
    width: 180px;
    font-family: Arial Narrow;
    border: solid 1px darkgray;
    font-size: 12px;
`;

export const ReportContainer = styled.div`
    max-width: max(90%, 1240px);
    margin-inline: auto;
`;

export const ReportContent = styled.article`
    padding: 15px;
    border-radius: 5px;
    background: white;
`;


const Aside = styled.div`
`;

const StickyContainer = styled.div`
    position: fixed;
    top: 120px;
    background: white;
    padding-inline: 5px;
    padding-bottom: 10px;
    border-radius: 5px;
`;

const ReportNavContainer = styled.div`
    padding: 10px;
`;

const ReportNavListItem = styled.p`
    font-size: 14px;
    text-align: left;
    margin-block: 5px;
    ${props => props.indented && css`
        margin-left: 15px;
    `}
`;

const FilterContainer = styled.div`
background-color: #ededed;
padding: 10px 20px;
color: #1b3e59;
border-radius: 2px;
    padding-inline: 10px;
    font-size: 12px;
`;

const CheckboxGroup = styled.div`
    max-height: 820px;
    overflow-y: none;
`;

const DestinationsList = styled.div`
    column-count: 1;
`;


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadNewEmployeeReport: loadNewEmployeeReport,
            loadNewEmployeeSharedReport: loadNewEmployeeSharedReport,
            downloadNewEmployeeReportData: downloadNewEmployeeReportData
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    NewEmployeeReportState: state.newEmployeeReportProperties
});

const queryString = window.location.href;
const hash = queryString.split('/');
const pageDescription = (hash.length == 8) ? "shared link report access" : "landing page";
export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(NewEmployeeReport, "Employee Profile Report", pageDescription));

